import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import keys from './keys';
import useApiQuery from '../useApiQuery';

const useGetFeatures = ({
  networkId: networkIdParam,
  showId: showIdParam,
  disabled = false,
} = {}) => {
  const { showId: currentShowId, networkId: currentNetworkId } = useParams();
  const showId = showIdParam || currentShowId;
  const networkId = networkIdParam || currentNetworkId;

  const query = useApiQuery({
    requestUrl: `/features/${networkId}${showId ? `?showId=${showId}` : ''}`,
    disabled: !networkId || disabled,
    queryKey: keys.list({ networkId, showId }),
  });

  return {
    featuresPermissions: query.data,
    featuresPermissionsError: query.error,
    isFeaturesPermissionsFetchError: query.isError,
    isFeaturesPermissionsFetchSuccess: query.isSuccess,
    isFeaturesPermissionsFetching: query.isFetching,
    isFeaturesPermissionsLoading: query.isInitialLoading,
    ...query,
  };
};

useGetFeatures.propTypes = {
  networkId: PropTypes.string,
  showId: PropTypes.string,
  disabled: PropTypes.bool,
};

export default useGetFeatures;
